import client, { PaginatedResponse, Response } from './client';
import { StoreDetails } from '../../types/store';

export type LoadStoresParams = {
  page: number;
  query?: string;
};

export type StoreLookupParams = {
  occ_phone_number: string;
};

export const loadStores = (params: LoadStoresParams): PaginatedResponse<StoreDetails> =>
  client.get(`/stores`, { params });

export const searchStore = (params: StoreLookupParams): Response<StoreDetails> =>
  client.get(`/store-lookup`, { params });

export const loadStoreDetails = (id: string): Response<StoreDetails> => client.get(`/stores/${id}`);
